import { useEffect, type RefObject } from 'react';

export function useScrollToTop(dep: unknown, scrollRef?: RefObject<HTMLElement | null>) {
  useEffect(() => {
    window.scrollTo(0, 0);
    scrollRef?.current?.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dep]);
}
